import { DEFAULT_AUTHORING_LAYER_ID } from '../config'
import { cleanDraftText } from '../utils/text'
import { createAuthoringState } from './state'

/**
 * Creates a layer record used by saved snippets, highlight bands, and exports.
 */
export function createAuthoringLayer(name = 'Main layer', id = '') {
  const layerId =
    cleanDraftText(id, 80) ||
    `layer_${Date.now()}_${Math.random()
      .toString(36)
      .slice(2, 7)}`
  return {
    id: layerId,
    name: cleanDraftText(name, 80) || 'Main layer',
    visible: true,
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  }
}

/**
 * Ensures legacy annotations always have a valid active layer and layer ids.
 */
export function ensureAuthoringLayerState(state) {
  const normalized = createAuthoringState(state)
  if (!normalized.layers.length) {
    normalized.layers = [
      createAuthoringLayer('Main layer', DEFAULT_AUTHORING_LAYER_ID),
    ]
  }
  if (!normalized.layers.some(layer => layer.id === normalized.activeLayerId)) {
    normalized.activeLayerId = normalized.layers[0].id
  }
  normalized.highlightBands.forEach(band => {
    if (!band.layerId) band.layerId = normalized.activeLayerId
  })
  normalized.storySnippets.forEach(snippet => {
    if (!snippet.layerId) snippet.layerId = normalized.activeLayerId
  })
  return normalized
}

export function getActiveAuthoringLayer(state) {
  const normalized = ensureAuthoringLayerState(state)
  return normalized.layers.find(layer => layer.id === normalized.activeLayerId)
}

export function getVisibleSavedHighlightBands(state) {
  const normalized = ensureAuthoringLayerState(state)
  return normalized.highlightBands.filter(
    band =>
      (band.layerId || normalized.activeLayerId) === normalized.activeLayerId
  )
}

export function getVisibleSavedStorySnippets(state) {
  const normalized = ensureAuthoringLayerState(state)
  return normalized.storySnippets.filter(
    snippet =>
      (snippet.layerId || normalized.activeLayerId) === normalized.activeLayerId
  )
}
